import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'src/app/services/local-storage.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-product-info-card',
  templateUrl: './product-info-card.component.html',
  styleUrls: ['./product-info-card.component.scss']
})
export class ProductInfoCardComponent {
  @Input() id: string = '';
  @Input() disableHoverTransform = false;
  @Input() newBadge: boolean = false;
  @Input() productImage: string = '';
  @Input() title: string = '';
  @Input() subtitleImage: string = '';
  @Input() hoverText: string = '';
  @Input() isCategoryCard: boolean = false;
  @Input() isDisplay:boolean = false;
  @Input() productCount: number = 0;
  @Input() subcategories: any[] = [];
  @Input() contentItems: { name: string; value: string; fromValue?: string; fromUnit?: string }[] = [];
  @Input() category:any;
  @Input() isViewAll = false;
  @Input() totalProductCount = 0;
  @Input() oemId: string = '';
  @Output() allProductsCount = new EventEmitter<any>();
  @Input() disableShadow = false;
  userId: any;

  constructor(
    private router: Router, private localStorageService: LocalStorageService){
      this.localStorageService.getUserDetails().subscribe(userDetails => {
        this.userId = userDetails?.userId;
      });
    }
  
  ngOnInit() {
    if(this.totalProductCount === undefined || this.totalProductCount === null || this.totalProductCount === 0) {
    } else if(this.totalProductCount && this.totalProductCount > 0) {
      this.allProductsCount.emit(this.totalProductCount);
    }
  }

checkUserLoginorNot(id: any) {
  const userId = this.userId;
  const roleName = this.localStorageService.getItem('roleName') ?? '';
  const storedOemId = this.localStorageService.getItem('oemId');

  if (!userId) {
    this.showLoginAlert();
    return;
  }

  if (roleName === 'SUPER_ADMIN') {
    this.showAlert('Enquiry Restricted!!', "Super Admin don't have access to Send Enquiry!!", 'error');
    return;
  }

  if (storedOemId && storedOemId === this.oemId) {
    this.showAlert('Invalid Action!', "Enquiries cannot be made on your own product.", 'warning');
    return;
  }   
  this.router.navigate(['/user/products/enquiry/', id]);
}


private showLoginAlert() {
  Swal.fire({
    iconHtml: '<img src="./assets/images/signin-icon.svg" height="90px" width="90px">',
    iconColor: '#ffffff',
    title: '<strong>Please log in to send a Product Enquiry</strong>',
    showCancelButton: true,
    confirmButtonText: 'Login',
    cancelButtonText: 'Cancel',
    html: `<p style="font-size: 13px; margin: 0px;"> Don't have an account? 
            <a href="/user/signup" 
            style="color: blue; font-size: 16px; font-weight: 600; text-decoration: underline; text-wrap:nowrap">
            Join Now</a></p>`,
    focusConfirm: false
  }).then((result) => {
    if (result.isConfirmed) {
      this.router.navigate(['/login']);
    }
  });
}

private showAlert(title: string, text: string, icon: 'error' | 'warning') {
  Swal.fire({
    title,
    text,
    icon,
    confirmButtonText: 'Ok',
    confirmButtonColor: '#0f74a9',
    allowOutsideClick: false
  });
}
}